export const BASIC_USER = 'basicUser';
export const TEAM_OWNER = 'teamOwner';

type RoleGroup = {
  title: string;
  roles: string[];
};

// in display order
export const roleGroups: RoleGroup[] = [
  { title: 'Admin', roles: [TEAM_OWNER, 'teamManager'] },
  { title: 'API Settings', roles: ['apiSettingsEditor'] },
  { title: 'Customizations', roles: ['customizationsEditor'] },
  { title: 'Payments', roles: ['paymentsViewer', 'paymentOpsUser'] },
  { title: 'Quickstart Links (Bank Data API)', roles: ['quickstartLinkEditor', 'quickstartDataAccessor'] },
];

export const allTeamRoles: string[] = [...roleGroups.flatMap((group) => group.roles), BASIC_USER];

export const selectableTeamRoles = allTeamRoles.filter((role) => role !== BASIC_USER);

type RoleInformation = {
  name: string;
  info: string;
  sensitive?: boolean;
};

export const roleToRoleInfo: Record<string, RoleInformation> = {
  teamOwner: { name: 'Team Owner', info: 'Full permissions (Super Admin)', sensitive: true },
  teamManager: { name: 'Team Manager', info: 'Update team members; no data access' },
  apiSettingsEditor: {
    name: 'API Settings Editor',
    info: 'Manage API keys and settings',
    sensitive: true,
  },
  customizationsEditor: {
    name: 'Customizations Editor',
    info: 'Manage customizations of the Finverse UI',
  },
  paymentsViewer: {
    name: 'Payments Viewer',
    info: 'View payments dashboards (Payments, Payment Methods, Users, Bills); no edit access',
  },
  paymentOpsUser: {
    name: 'Payments Ops User',
    info: 'Payments Viewer role + update Payment Methods and Users',
  },
  quickstartLinkEditor: {
    name: 'Quickstart Link Editor',
    info: 'Manage Quickstart Links to connect user bank accounts; no data access',
  },
  quickstartDataAccessor: {
    name: 'Quickstart Data Accessor',
    info: 'Download user bank data connected through Quickstart Links',
    sensitive: true,
  },
  basicUser: { name: 'Basic User', info: 'Can read non-sensitive information only' },
};

// TODO: remove this with the v1 members page, which is its only user
export const displayRoles = (roles: string[]): string => {
  if (roles.length === 1 && roles[0] === BASIC_USER) {
    return roleToRoleInfo[roles[0]].name;
  }

  // remove basic user
  return roles
    .filter((role) => role !== BASIC_USER)
    .map((role) => roleToRoleInfo[role]?.name ?? '')
    .filter((role) => role !== '')
    .join(', ');
};

// roles to display as chips: teamOwner alone since it includes every other role, otherwise in display order without basicUser
export const rolesToDisplay = (roles: string[]): string[] => {
  if (roles.includes(TEAM_OWNER)) {
    return [TEAM_OWNER];
  }
  return selectableTeamRoles.filter((role) => roles.includes(role));
};
